"use client";

import { createTheme } from "@mantine/core";

export const theme = createTheme({
  // Themeを設定
  // https://mantine.dev/theming/theme-object/#usage
});
